/**
 * created by wang lei
 行间距页面
 *
 */
import React, {Component} from 'react';
import rowHeight from './rowHeight.png';
import SelectTool from "../components/selectTool";
import {EDITOR_TOOL_BTN_COLOR} from "../../../../../constants";

export default class RowHeightTool extends Component {
    constructor(props) {
        super(props);
        this.state = {
            options:[
                {key:1, val:'1', checked: false},
                {key:'1.5', val:'1.5', checked: false},
                {key:'1.75', val:'1.75', checked: false},
                {key:'2', val:'2', checked: false},
                {key:'3', val:'3', checked: false},
                {key:'4', val:'4', checked: false},
                {key:'5', val:'5', checked: false},
            ],
            defaultOption: '1',
        }
    }
    /**
     * 监听内容变化
     */
    listenContentChange(){
        let ulKey = this.props.editor.queryCommandValue( 'lineheight');
        this.state.options.map(item=>{
            if(item.key ===  ulKey ){
                item.checked = true;
            }else{
                item.checked = false;
            }
        });
        this.setState({});
    }
    /**
     * 监听编辑器点击
     */
    listenContentClick(){
        let ulKey = this.props.editor.queryCommandValue( 'lineheight');
        this.state.options.map(item=>{
            if(item.key ===  ulKey ){
                item.checked = true;
            }else{
                item.checked = false;
            }
        });
        this.selectTool.hide();
        this.setState({});
    }

    render() {
        return <div style={{display: 'inline-block'}}>
            <div className={"editor-rowHeight-tool-btn"}>
                <SelectTool
                    ref={ref => this.selectTool = ref}
                    editor={this.props.editor}
                    options={this.state.options}
                    defaultOption={'1'}
                    configKey={'lineheight'}
                    imgUrl={rowHeight}
                />
            </div>
            <style>{`
                .editor-rowHeight-tool-btn{
                    border: 1px solid #f2f6fc
                }
                .editor-rowHeight-tool-btn:hover{
                    border: 1px solid ${EDITOR_TOOL_BTN_COLOR.hover}
                }
                .editor-rowHeight-tool-btn:active{
                    border: 1px solid ${EDITOR_TOOL_BTN_COLOR.press}
                }
            `}</style>
        </div>
    }
}